var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.451901 8.5004C0.451901 8.13947 0.749223 7.84415 1.11886 7.84415L16.2778 7.84416L10.6247 1.72052C10.3773 1.45265 10.3975 1.0372 10.6696 0.793979C10.7979 0.682826 10.9586 0.625405 11.1193 0.625405C11.3003 0.625405 11.4813 0.697182 11.6127 0.840737L18.2783 8.05949C18.5094 8.30944 18.5094 8.69154 18.2783 8.94132L11.6127 16.1601C11.364 16.4292 10.9421 16.4472 10.6705 16.2049C10.3984 15.9614 10.3782 15.5462 10.6256 15.2784L16.2778 9.15665L1.11846 9.15665C0.749222 9.15665 0.451901 8.86134 0.451901 8.5004Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.2c9c3092bed766c524bcd2bdc42ce51d.svg";
export { ForwardRef as ReactComponent };